export default __webpack_public_path__ + "static/media/Incorrect.bd8dc25e.wav";